export default "__VITE_ASSET__ef0edb9b__"